/* FleetPro Filters Module v1.0.0 - fp-predictive-fuzzy.js
   Typo-tolerant fallback for Athens native predictive search. Fires ONLY when native predictive
   returns 0 products: corrects query words against a catalog vocabulary (instant embedded seed +
   on-demand augment from /products.json, cached 24h), re-queries the suggest endpoint, then swaps
   the dropdown contents. Never alters a query that already returned products. Additive, standalone,
   safe to remove. Debug: set window.__fpFiltersDebug = true for warnings. See FP_FILTERS_MODULE.md. */
(function () {
  if (window.__fpFuzzy) return; window.__fpFuzzy = true;

  var fp = (window.fpFilters = window.fpFilters || { version: '1.0.0', loaded: {} });
  fp.loaded.fuzzy = '1.0.0';
  function warn() {
    if (window.__fpFiltersDebug && window.console && console.warn)
      console.warn.apply(console, ['[fp-filters/fuzzy]'].concat([].slice.call(arguments)));
  }

  var CK = 'fp_fuzzy_vocab_v1', TTL = 864e5; // 24h

  // Instant seed so corrections work before /products.json loads.
  var SEED = ('cascadia freightliner volvo mack peterbilt kenworth international western columbia coronado '
    + 'detroit diesel cummins paccar navistar eaton meritor wabco bendix hendrickson '
    + 'automann lexmont decatur michelin yokohama worldtrack royal black skyline phillips illinois continental '
    + 'elring sensata mahle neapco stabilus alliance firestone econoride everco norgren fleetpro zeta '
    + 'bumper grille mirror fairing fender splash shield headlight fog light marker clearance lamp hood '
    + 'brake drum shoe chamber slack adjuster camshaft rotor caliper sensor abs '
    + 'clutch actuator solenoid valve manifold transmission drivetrain flywheel '
    + 'filter cabin fuel coolant radiator reservoir tank water pump thermostat '
    + 'belt tensioner gasket seal engine exhaust muffler clamp dpf '
    + 'mudflap mudguard hanger bracket suspension shock spring bushing drag link '
    + 'battery cable fuse terminal relay switch motor compressor blower drier accumulator condenser '
    + 'tire steer drive trailer position tread radial '
    + 'tarp lumber coil strap ratchet winch chain binder hook corner protector bungee '
    + 'toolbox headache rack gladhand pigtail connector plug socket conestoga flatbed deck '
    + 'cover bracket holder reinforcement assembly').split(/\s+/);

  var vocab = SEED.slice();
  function union(a, b) { var s = {}, o = []; a.concat(b).forEach(function (w) { if (w && !s[w]) { s[w] = 1; o.push(w); } }); return o; }

  function addWords(map, s) {
    if (!s) return;
    var w = String(s).toLowerCase().replace(/[^a-z0-9\s\/-]/g, ' ').split(/[\s\/\-]+/);
    for (var i = 0; i < w.length; i++) { var x = w[i]; if (x.length >= 4 && !/\d/.test(x)) map[x] = (map[x] || 0) + 1; }
  }
  async function build() {
    var map = {};
    var ac = ('AbortController' in window) ? new AbortController() : null;
    var killed = false;
    var deadline = ac ? setTimeout(function () { killed = true; try { ac.abort(); } catch (e) {} }, 4000) : null;
    try {
      for (var page = 1; page <= 6; page++) {
        var r;
        try { r = await fetch('/products.json?limit=250&page=' + page, { headers: { Accept: 'application/json' }, signal: ac ? ac.signal : undefined }); }
        catch (e) { if (killed) warn('vocab augment timed out at page ' + page); break; }
        if (!r.ok) break;
        var d = await r.json(), ps = (d && d.products) || [];
        if (!ps.length) break;
        for (var k = 0; k < ps.length; k++) {
          var p = ps[k];
          addWords(map, p.title); addWords(map, p.vendor); addWords(map, p.product_type);
          var tg = p.tags || [];
          for (var m = 0; m < tg.length; m++) addWords(map, String(tg[m]).replace(/^(category|subsub|sub|make|position):/i, ''));
        }
        if (ps.length < 250) break;
      }
    } finally { if (deadline) clearTimeout(deadline); }
    var out = []; for (var w in map) if (map[w] >= 2) out.push(w); return out;
  }
  var augmentStarted = false;
  function augment() {
    if (augmentStarted) return;
    augmentStarted = true;
    try {
      var c = JSON.parse(localStorage.getItem(CK) || 'null');
      if (c && c.t && Date.now() - c.t < TTL && c.w && c.w.length) { vocab = union(SEED, c.w); return; }
    } catch (e) {}
    build().then(function (w) {
      if (w && w.length) { vocab = union(SEED, w); try { localStorage.setItem(CK, JSON.stringify({ t: Date.now(), w: w })); } catch (e) {} }
    }).catch(function (e) { warn('vocab augment failed', e); });
  }

  // Catalog vocabulary is useful only after someone starts searching. Waiting
  // for intent avoids parsing up to six /products.json pages on every visit.
  function onSearchIntent(e) {
    var target = e.target;
    if (!target || !target.closest || !target.closest('predictive-search')) return;
    augment();
    document.removeEventListener('focusin', onSearchIntent);
    document.removeEventListener('pointerdown', onSearchIntent);
  }

  function lev(a, b, max) {
    var la = a.length, lb = b.length, i, j, t;
    if (Math.abs(la - lb) > max) return max + 1;
    var prev = [], cur = [];
    for (j = 0; j <= lb; j++) prev[j] = j;
    for (i = 1; i <= la; i++) {
      cur[0] = i; var best = i;
      for (j = 1; j <= lb; j++) {
        var c = a.charCodeAt(i - 1) === b.charCodeAt(j - 1) ? 0 : 1;
        cur[j] = Math.min(prev[j] + 1, cur[j - 1] + 1, prev[j - 1] + c);
        if (cur[j] < best) best = cur[j];
      }
      if (best > max) return max + 1;
      t = prev; prev = cur; cur = t;
    }
    return prev[lb];
  }
  function fix(word) {
    if (word.length < 4 || /\d/.test(word)) return word;
    var max = word.length <= 5 ? 1 : 2, best = null, bd = max + 1;
    for (var i = 0; i < vocab.length; i++) {
      var c = vocab[i];
      if (c === word) return word;
      if (Math.abs(c.length - word.length) > max) continue;
      if (c.charCodeAt(0) !== word.charCodeAt(0) && c.charCodeAt(c.length - 1) !== word.charCodeAt(word.length - 1)) continue;
      var d = lev(word, c, max);
      if (d < bd) { bd = d; best = c; if (d === 1) break; }
    }
    return best && bd <= max ? best : word;
  }
  function correct(q) {
    var changed = false;
    var out = q.split(/\s+/).map(function (p) {
      var core = p.toLowerCase().replace(/[^a-z0-9]/g, '');
      if (!core) return p;
      var f = fix(core);
      if (f !== core) { changed = true; return f; }
      return p;
    });
    return changed ? out.join(' ') : null;
  }

  function pcount(el) { return el.querySelectorAll('a[href*="/products/"]').length; }
  function purl(q) {
    var base = (window.routes && routes.predictive_search_url) || '/search/suggest';
    return base + '?q=' + encodeURIComponent(q)
      + '&resources[limit]=6&options[prefix]=last&section_id=predictive-search'
      // Keep this list identical to predictive-search.js - a fuzzy retry that
      // searches fewer fields than the first attempt can only ever find less.
      + '&resources[options][fields]=title,product_type,variants.title,variants.sku,vendor,tag,body';
  }
  async function tryFuzzy(ps) {
    var input = ps.querySelector('input[type=search]'), box = ps.querySelector('[data-predictive-search]');
    if (!input || !box) return;
    var q = (input.value || '').trim();
    if (q.length < 3) return;
    if (pcount(box) > 0) return;                 // native found products - never touch
    if (ps.__fpQ === q) return; ps.__fpQ = q;
    var fixed = correct(q);
    if (!fixed || fixed.toLowerCase() === q.toLowerCase()) return;
    var r; try { r = await fetch(purl(fixed)); } catch (e) { return; }
    if (!r.ok) return;
    if ((input.value || '').trim() !== q) return; // user kept typing
    var sec = new DOMParser().parseFromString(await r.text(), 'text/html').querySelector('#shopify-section-predictive-search');
    if (!sec) return;
    var tmp = document.createElement('div'); tmp.innerHTML = sec.innerHTML;
    if (pcount(tmp) === 0) return;                // correction found nothing - leave native as-is
    if ((input.value || '').trim() !== q) return;
    ps.__fpBusy = true;
    var safe = fixed.replace(/[<>&"]/g, '');
    box.innerHTML = '<div role="status" aria-live="polite" style="padding:8px 14px;font-size:13px;color:#5b6b85">Showing results for <strong>' + safe + '</strong></div>' + sec.innerHTML;
    try { if (typeof ps.open === 'function') ps.open(); } catch (e) {}
    ps.setAttribute('results', 'true'); ps.setAttribute('open', 'true');
    setTimeout(function () { ps.__fpBusy = false; }, 60);
  }
  // #3 "See all results" - when the dropdown shows 0 products, offer a click-through to full /search
  // (full search is stronger than predictive and handles cases predictive/fuzzy miss). Raw query.
  function ensureSeeAll(ps) {
    var input = ps.querySelector('input[type=search]'), box = ps.querySelector('[data-predictive-search]');
    if (!input || !box) return;
    var q = (input.value || '').trim();
    var ex = box.querySelector('.fp-see-all');
    if (q.length < 3 || box.querySelector('a[href*="/products/"]')) { if (ex) { ps.__fpBusy = true; ex.remove(); setTimeout(function () { ps.__fpBusy = false; }, 40); } return; }
    if (ex) return; // already present for this 0-result state
    ps.__fpBusy = true;
    var a = document.createElement('a');
    a.className = 'fp-see-all';
    a.href = '/search?q=' + encodeURIComponent(q);
    a.setAttribute('style', 'display:block;padding:11px 14px;font-size:13px;font-weight:600;color:#1F4EC9;text-decoration:none;border-top:1px solid #e3e8f0');
    a.textContent = 'See all results for “' + q + '” →';
    box.appendChild(a);
    setTimeout(function () { ps.__fpBusy = false; }, 60);
  }

  function watch(ps) {
    var box = ps.querySelector('[data-predictive-search]');
    if (!box || ps.__fpWatch) return; ps.__fpWatch = true;
    var t;
    new MutationObserver(function () {
      if (ps.__fpBusy) return;
      clearTimeout(t); t = setTimeout(function () { tryFuzzy(ps).then(function () { ensureSeeAll(ps); }); }, 160);
    }).observe(box, { childList: true, subtree: true });
  }
  function init() { var l = document.querySelectorAll('predictive-search'); for (var i = 0; i < l.length; i++) watch(l[i]); }

  document.addEventListener('focusin', onSearchIntent);
  document.addEventListener('pointerdown', onSearchIntent, { passive: true });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  setTimeout(init, 1500);
})();
